import { FC } from 'react';
import ActionButton from 'components/ActionButton';
import { ActionButtonProps } from 'components/ActionButton/ActionButton';
import Box from 'yoda-ui/components/Box';
import { YodaColors, YodaFontSize, YodaSpacing } from 'yoda-ui/yodaTheme';

export type StepButtonsConfig = {
  firstButton?: ActionButtonProps;
  secondButton?: ActionButtonProps;
  thirdButton: ActionButtonProps;
};

const buttonStyle = {
  justifyContent: 'start',
  backgroundColor: YodaColors.transparent,
  borderWidth: '0px',
  padding: '12px 0',
  fontSize: YodaFontSize.small,
  color: YodaColors.blue7,
  width: 'fit-content',

  '&:hover': {
    color: YodaColors.blue8,
  },
};

const ButtonsBar: FC<StepButtonsConfig> = ({ firstButton, secondButton, thirdButton }) => (
  <Box
    display="flex"
    flexDirection="row"
    justifyContent="space-between"
    marginTop={ YodaSpacing.large }
  >
    <Box>
      {
        firstButton && (
          <ActionButton
            { ...firstButton }
            buttonProps={
              {
                ...firstButton.buttonProps,
                styles: buttonStyle,
              }
            }
          />
        )
      }
    </Box>
    <Box
      display="flex"
      flexDirection="row"
      justifyContent="flex-end"
    >
      {
        secondButton
      && <Box marginRight={ YodaSpacing.medium }>
        <ActionButton
          { ...secondButton }
        />
      </Box>
      }
      <ActionButton { ...thirdButton } />
    </Box>
  </Box>
);

export default ButtonsBar;
